(ns client-portal.client.voice-insights.ai-analyst.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.core.data :as core.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.items.charts.data :as items.charts.d]
            [client-portal.client.vi.components.tag :as tag]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:voice-insights :ai-analyst])
(def data-path (conj root-path :data))
(def settings-path (conj root-path :settings))

(re/reg-event-db
  :vi-ai-analyst/initialize-filters re/middleware
  (fn [db]
    (core.d/initialize-common-filters db)))

(re/reg-event-fx
  :vi-ai-analyst/initialize re/middleware
  (fn [{:keys [db]}]
    (re/dispatch [:vi-ai-analyst/initialize-filters])
    (re/dispatch [:vi-ai-analyst/reload])
    {:db db
     :forward-events {:register :vi-ai-analyst-initialization-listener
                      :events #{:concepts/select :locations/select :core/select-crew-type
                                :core/select-timeframe :locations/clear-selected
                                :core/timeframe-date-range-changed}
                      :dispatch-to [:vi-ai-analyst/reload]}}))

(re/reg-event-db
  :vi-ai-analyst/reload re/middleware
  (fn [db]
    (-> db
        (assoc-in data-path nil))))

(defn transf-x-and-bot-issues [d & {:keys [x-tag? x-display-name-fn]}]
  (when (not-empty d)
    (let [total-counts (items.charts.d/build-total-counts d :x)]
      {:data (->> d
                  (mapv (fn [r]
                          (cond-> (assoc r :issue (tag/tag->display-name {:value (:issue r)})
                                           :issue-raw (:issue r)
                                           :total-count (get total-counts (:x r)))
                                  x-tag?
                                  (assoc :x (if x-display-name-fn
                                              (x-display-name-fn (:x r))
                                              (tag/tag->display-name {:value (:x r)}))
                                         :x-raw (:x r)))))
                  (sort-by :total-count)
                  (reverse))
       :top-20-keys (items.charts.d/total-counts->top-20-keys total-counts)})))

(defn transf-data [d]
  (-> d
      (update :menu-items-and-bot-issues transf-x-and-bot-issues)
      (update :ai-outcomes-and-bot-issues #(transf-x-and-bot-issues % :x-tag? true))
      (update :ai-escalations-and-bot-issues #(transf-x-and-bot-issues
                                                %
                                                :x-tag? true
                                                :x-display-name-fn (fn [x-val]
                                                                     (condp = x-val
                                                                       "ai-escalation" "AI"
                                                                       "customer-escalation" "Customer"
                                                                       "takeover-ai_crew" "Crew"
                                                                       x-val))))))

(re/reg-auth0-loader
  :vi-ai-analyst/load-data
  data-path
  (fn [db _]
    (when (concepts.d/current-concept-id db)
      {:method :post
       :url "/api/vi/ai-analyst/data"
       :json-params (vi.d/base-query-args db {})}))
  :transf #(or (some-> % :body (util/->kebab-case-keywords) (transf-data)) [])
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :vi-ai-analyst/data-
  data-path
  :vi-ai-analyst/load-data)
